module.exports = __webpack_public_path__ + "static/media/titulo_gestion.98b05043.png";